import { Typography } from '@shared/ui'
import styles from './Navbar.module.scss'
import { navigation, routes } from '@shared/constants/constants'
import { useScroll } from '@shared/hooks/useScroll'
import { IconClose, IconMenu } from '@shared/assets'
import { LanguageSelect } from '@features/languages'
import { useState } from 'react'
import classNames from 'classnames'
import { useMediaQuery } from '@shared/hooks/useMediaQuery'
import { useClickOutside } from '@shared/hooks/useClickOutside'
import { useTranslation } from 'react-i18next'
import { CustomButton } from '@shared/ui'


export const Navbar = () => {
  const { scrollToBlock } = useScroll()
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const isTablet = useMediaQuery('(max-width: 976px)')
  const burgerRef = useClickOutside(() => setIsMenuOpen(false))
  const toggleMenu = () => setIsMenuOpen((prev) => !prev)
  const { t } = useTranslation()

  return (
    <>
      {isMenuOpen && isTablet && (
        <div
          className={styles.overlay}
          onClick={() => setIsMenuOpen(false)}
        />
      )}
      <nav ref={burgerRef} className={styles.navbar}>
        <div onClick={toggleMenu} className={styles.burgerMenu}>
          <IconMenu />
        </div>
        <div className={classNames(styles.burgerDropdown, {
          [styles.showMenu]: isMenuOpen && isTablet,
          [styles.hideMenu]: !isMenuOpen && isTablet,
        })}>
          <div className={styles.burgerClose}>
            <LanguageSelect className={styles.lang} />
            <div onClick={() => setIsMenuOpen(false)}>
              <IconClose />
            </div>
          </div>
          <ul className={styles.navbarList}>
            {navigation.map((item) =>
              <li onClick={() => {
                scrollToBlock(item.id)
                toggleMenu()
              }} key={item.id}>
                <Typography
                  variant='h6regular'
                  color='black'
                >
                  {t(item.title)}
                </Typography>
              </li>
            )}
          </ul>
          <CustomButton
            className={styles.btn}
            to={routes.kitAward}
            onClick={() => setIsMenuOpen(false)}

            variant='white'
            actionType='link'
          >
            {t('buttons.leaveRequest')}
          </CustomButton>
        </div>
      </nav>
    </>
  )
}
